import React, { Component } from 'react';
import { connect } from 'react-redux';

import SearchField from './SearchField';
import SearchResults from './SearchResults';
import {
  initCategories,
  initLanguage,
  initTranslations,
  performSearch,
  setPage,
  initContactTranslations
} from './actions.mjs';
import SearchTitle from './SearchTitle';
import SearchFilters from './SearchFilters';
import SearchPagination from './SearchPagination';
import SearchErrorMessage from './SearchErrorMessage';


class Search extends Component {
  constructor(props) {
    super(props);
    props.dispatch(initCategories(JSON.parse(props.categories)));
    props.dispatch(initTranslations(JSON.parse(props.translations)));
    props.dispatch(initContactTranslations(JSON.parse(props.contactTranslations)));
    props.dispatch(initLanguage(props.language));
  }

  componentDidMount() {
    this.props.dispatch(performSearch());
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.category !== prevProps.category ||
      this.props.query !== prevProps.query
    ) {
      this.props.dispatch(setPage(1));
    }
    this.props.dispatch(performSearch());
  }

  render() {
    return (
      <div className="search-page">
        <div className="container-fluid search-page__top">
          <SearchTitle />
          <SearchField />
          <SearchFilters />
        </div>
        <div className="container-fluid search-page__bottom">
          <SearchErrorMessage />
          <SearchResults />
          <SearchPagination />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    page: state.page,
    query: state.query,
    category: state.category,
  };
}

export default connect(mapStateToProps)(Search);
